import { Box, Card, CardContent, CardHeader, Divider } from "@mui/material";
import { observer } from "mobx-react-lite";
import React from 'react';
import { useStore } from "../../stores/store";

interface Props {
  title?: string;
  subtitle?: string;  
  children?: JSX.Element | JSX.Element[];
}

const RkdCard = React.forwardRef<HTMLDivElement, Props>((props: Props, ref) => {
  const { children, title, subtitle } = props;  
  const child = React.Children.toArray(children);
  const { stationIdQuery } = useStore().commonStore
  
  return (
    <Card ref={ref} sx={{ boxShadow: 2, mb: 3, height: stationIdQuery ? 'calc(100vh - 35px)' : '100%', overflowY: "auto" }}>
      { title &&
        <CardHeader
          title={title}
          subheader={subtitle}
          titleTypographyProps={{ variant: 'h2', color: 'primary.contrastText' }}
          subheaderTypographyProps={{ variant: 'subtitle1', color: 'primary.contrastText' }}
          sx={{ bgcolor: 'primary.main' }}
        /> 
      }
      <Divider />
      <CardContent>
        <Box sx={{ display: 'flex', flexDirection: 'column'}}>
          {child.length >= 1 ? child.map((item, idx) => (
              <Box key={idx} sx={{ my: 1 }}>{item}</Box>
          )): ""} 
        </Box>  
      </CardContent>
    </Card>
  );
})

export default observer(RkdCard);
